<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="'版面顏色調整'"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <select v-validate="'required'" name="styleSet" v-model="colorStyle" @change="changeGroup">
                    <option v-for="(item, key, index) in selectColorGroup" :value="key" :key="index">
                        {{ item }}
                    </option>
                </select>
                <div class="md form-table">
                    <table>
                        <tr
                            v-for="(item, key) in colorData"
                            :key="key"
                        >
                            <th><label :for="key">{{ colorObject[key] }}</label></th>
                            <td>
                                <div class="cp input color" :class="[errors.has(key)? 'is-error': '']" :data-error="errors.first(key)">
                                    <input v-model="colorData[key]" type="color" v-validate="'required'" :name="key" :id="key" @change="changeColor">
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            align="center"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>
<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'
    import VueCookie from 'vue-cookie'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $htmlNode = document.querySelector('html'),
                $colorObject = {
                    'major-color': '主色',
                    'minor-color': '次色',
                    'forth-color': '選項顏色',
                    'tag-color': '標籤顏色',
                    // 'level03-color': '等級 3',
                    // 'level04-color': '等級 4',
                    // 'level05-color': '等級 5',
                    // 'white': '白色',
                    // 'light': '淺色',
                    // 'light-gray': '淺灰',
                    // 'gray': '灰色',
                    // 'deep-gray': '深灰',
                    // 'deep': '深色',
                    // 'black': '黑色',
                    // 'darkMode_light': '暗模式_淺色',
                    // 'darkMode_light-gray': '暗模式_淺灰',
                    // 'darkMode_gray': '暗模式_灰色',
                    // 'darkMode_deep-gray': '暗模式_深灰',
                    // 'darkMode_deep': '暗模式_深色',
                    // 'darkMode_black': '暗模式_黑色',
                },
                $selectColorGroup = {
                    origin: '預設',
                    snowBlue: '冰雪藍',
                    forestGreen: '森林綠',
                    infernoRed: '烈焰紅',
                    spaceGrey: '太空灰',
                    orange: '朝陽橙',
                    userSet: '自訂'
                },
                $colorGroup = {
                    origin: { //預設
                    },
                    snowBlue: { //冰雪藍
                        'major-color': "#77bcfd",
                        'minor-color': "#acc7fb",
                        'forth-color': "#0c6ba7",
                        'tag-color': "#77cafd",
                    },
                    forestGreen: { //森林綠
                        "major-color": "#0a6b2f",
                        "minor-color": "#a3f099",
                        "forth-color": "#098b12",
                        "tag-color": "#43c332",
                    },
                    infernoRed:{ //烈焰紅
                        "major-color": "#fb4f3c",
                        "minor-color": "#f4aeae",
                        "forth-color": "#cf0c0c",
                        "tag-color": "#f7733b",
                  
                    },
                    spaceGrey:{ //太空灰
                        "major-color": "#7e7c7c",
                        "minor-color": "#c7c7c7",
                        "forth-color": "#5e5e5e",
                        "tag-color": "#b6b8be",
                    },
                    orange:{ //朝陽橙
                        "major-color": "#dc7718",
                        "minor-color": "#e5b68f",
                        "forth-color": "#ea7910",
                        "tag-color": "#fdb721",
                    },
                },
                $keys = Object.keys($colorObject);

            return {
                htmlNode: $htmlNode,
                colorObject: $colorObject, //中英文對照
                selectColorGroup: $selectColorGroup, //預設群組選取
                colorGroup: $colorGroup,//預設顏色群組
                keys: $keys,
                colorData: {}, //資料
                colorStyle: ''
            }
        },
        computed: {
            btns: function(){
                let $close = {
                        text:this.$t('site.func.popupclose'),
                        themes: 'major',
                        func: 'close',
                    },
                    $action = {
                        text: '確定',
                        themes: 'info',
                        func: 'action',
                    },
                    $revert ={
                        text: '還原預設值',
                        themes: 'danger',
                        func: 'revert',
                    } 

                let $results = [
                        $action,
                        $revert,
                        $close
                    ]

                return $results;
            },
        },
        methods: {
            action: function(){
                if (this.colorStyle === 'origin'){
                    this.revert()
                }else{
                    let $colorData = this.colorData,
                    $keys = this.keys,
                    _result = '';

                    $keys.forEach(item => {
                        let _color = $colorData[item],
                            $color = this.$okaTool.hexToRgb(_color),
                            _rgb = $color.join(',');

                        _result += ('--'+ item +':'+ _rgb +';');
                    });
                    
                    this.htmlNode.setAttribute('style', _result);

                    VueCookie.set('colorSetLog', _result, 365);
                }
                this.close();
                    
                if( this.content.callback && typeof this.content.callback === 'function' ) {
                    this.content.callback();
                }
            },
            changeColor: function(){
                let $colorGroup = this.colorGroup,
                    $colorData = this.colorData,
                    $styleName = ''
                    
                    console.log($colorData)

                for(let i in $colorGroup){
                   
                    if(JSON.stringify($colorData) === JSON.stringify($colorGroup[i])){
                        $styleName = i
                        break;
                    }
                }

                if( !$styleName ){
                    $styleName = 'userSet'
                }

               this.$set(this, 'colorStyle', $styleName)
            },
            changeGroup: function(){

                let $colorGroup = this.$okaTool.copy( this.colorGroup),
                    $color ={}
                    
                if(this.colorStyle === 'userSet'){
                    //讓他自己玩
                }else{
                    for (let i in $colorGroup){
                        if(this.colorStyle === i){
                            $color = $colorGroup[i]
                            break;
                        }
                    }

                    this.$set(this, 'colorData',  $color)
                }
            },
            revert: function(){
                console.log(this.htmlNode)
                this.htmlNode.removeAttribute('style');
                

                VueCookie.delete('colorSetLog');

                this.init();
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            getOriginColor: function(){
                let _colorSetLog = VueCookie.get('colorSetLog'); //現在設定的顏色

                this.htmlNode.removeAttribute('style'); //先取消設定

                let $colorData = this.getColorHex() //取的預設的顏色

                this.htmlNode.setAttribute('style', _colorSetLog); //在把設定加回去

                let $colorGroup = this.colorGroup
                    
                $colorGroup.origin = $colorData
            },
            getColorHex: function(){
                let $computedStyle = getComputedStyle(this.htmlNode), //取紀錄 
                    $colorData = {}

                this.keys.forEach(item => {
                    let _color = $computedStyle.getPropertyValue('--'+ item);

                    _color = _color.replaceAll(' ', '');

                    let $color = _color.split(',');

                    $color = $color.map(item => parseInt(item, 10))

                    let _hex = this.$okaTool.rgbToHex($color);
                        
                    $colorData[item] = _hex;
                });

                return $colorData
            },
            init: function(){
                let $colorData = this.getColorHex()
             
                this.getOriginColor()
                this.$set(this, 'colorData', $colorData);
                this.changeColor()
            },
        },
        created: function(){
            this.init();
        }
    }
</script>
